﻿ import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPageLayout from "./domain/landingpage/layout/LandingPageLayout";
import LandingpagePage from "./pages/landingpage/LandingpagePage";
import AppShell from "./domain/platform_core/shell/components/AppShell";
import DashboardPage from "./pages/dashboard/DashboardPage";
import EmailVerification from "./domain/platform_core/auth/components/EmailVerification";
import MarginCalculatorPage from "./pages/margincalculator/MarginCalculatorPage";
import Dashboard from "./domain/margincalculator/dashboard/components/Dashboard";
import Calculator from "./domain/margincalculator/calculator/components/Calculator";
import Offers from "./domain/margincalculator/offers/components/Offers";
import Customers from "./domain/margincalculator/customer/components/Customers";
import Contracts from "./domain/margincalculator/contracts/components/Contracts";
import Calendar from "./domain/margincalculator/calendar/components/Calendar";
import News from "./domain/margincalculator/news/components/News";
import Bundles from "./domain/margincalculator/bundles/components/Bundles";
import Inbox from "./domain/margincalculator/inbox/components/Inbox";
import Reports from "./domain/margincalculator/reports/components/Reports";
import Team from "./domain/margincalculator/team/components/Team";
import MyData from "./domain/margincalculator/my-data/components/MyData";
import Security from "./domain/margincalculator/security/components/Security";
import License from "./domain/margincalculator/license/components/License";
import ShopSettings from "./domain/margincalculator/shop-settings/components/ShopSettings";
import EmployeeRights from "./domain/margincalculator/employee-rights/components/EmployeeRights";
import NewsManagement from "./domain/margincalculator/news-management/components/NewsManagement";
import QuantityBonuses from "./domain/margincalculator/quantity-bonuses/components/QuantityBonuses";
import CockpitPage from "./pages/cockpit/CockpitPage";
import CockpitDashboard from "./domain/cockpit/portfolio/components/Cockpit/CockpitDashboard";
import EsgCo2 from "./domain/cockpit/portfolio/components/EsgCo2/EsgCo2";
import CRMPage from "./pages/crm/CRMPage";
import SalesPage from "./pages/sales/SalesPage";
import SalesDashboard from "./domain/sales/dashboard/components/Dashboard";
import SalesCustomers from "./domain/sales/customer/components/Customers";
import SalesCustomerList from "./domain/sales/customer/components/CustomerList/CustomerList";
import CustomerAnalysis from "./domain/sales/customer/components/CustomerAnalysis/CustomerAnalysis";
import SalesEmployeeRights from "./domain/sales/employee/components/Rights/Rights";
import SalesRateOverview from "./domain/sales/employee/components/RateOverview/RateOverview";
import SalesEmployeeNotifications from "./domain/sales/employee/components/Notifications/Notifications";
import SalesContracts from "./domain/sales/contracts/components/Contracts";
import SalesVVLList from "./domain/sales/contracts/components/VVL-List/VVL_List";
import ContractOverview from "./domain/sales/contracts/components/ContractOverview/ContractOverview";
import VVLCampaign from "./domain/sales/contracts/components/VVLCampaign/VVLCampaign";
import CashRegister from "./domain/sales/cash-register/components/CashRegister";
import NewWithdrawal from "./domain/sales/cash-register/components/NewWithdrawal/NewWithdrawal";
import CashUp from "./domain/sales/cash-register/components/CashUp/CashUp";
import CashReport from "./domain/sales/cash-register/components/CashReport/CashReport";
import DocumentHistory from "./domain/sales/cash-register/components/DocumentHistory/DocumentHistory";
import DocumentDetails from "./domain/sales/cash-register/components/DocumentDetails/DocumentDetails";
import OpenItems from "./domain/sales/cash-register/components/OpenItems/OpenItems";
import CashRegisterOffers from "./domain/sales/cash-register/components/Offers/Offers";
import OpenCashRegister from "./domain/sales/cash-register/components/OpenCashRegister/OpenCashRegister";
import Invoice from "./domain/sales/cash-register/components/Invoice/Invoice";
import Stock from "./domain/sales/stock/components/Stock";
import GoodsReceived from "./domain/sales/stock/components/GoodsReceived/GoodsReceived";
import GoodsOut from "./domain/sales/stock/components/GoodsOut/GoodsOut";
import ArticleManagement from "./domain/sales/stock/components/ArticleManagement/ArticleManagement";
import GoodsReceiptBooking from "./domain/sales/stock/components/GoodsReceiptBooking/GoodsReceiptBooking";
import GoodsIssueBooking from "./domain/sales/stock/components/GoodsIssueBooking/GoodsIssueBooking";
import LabelPrinting from "./domain/sales/stock/components/LabelPrinting/LabelPrinting";
import ImeiSearch from "./domain/sales/stock/components/ImeiSearch/ImeiSearch";
import QuantityInventory from "./domain/sales/stock/components/QuantityInventory/QuantityInventory";
import SerialNumberInventory from "./domain/sales/stock/components/SerialNumberInventory/SerialNumberInventory";
import EanInventory from "./domain/sales/stock/components/EanInventory/EanInventory";
import StockValue from "./domain/sales/stock/components/StockValue/StockValue";
import Inventories from "./domain/sales/stock/components/inventories/Inventories";
import RankingList from "./domain/sales/stock/components/RankingList/RankingList";
import StockInTransit from "./domain/sales/stock/components/StockInTransit/StockInTransit";
import Repair from "./domain/sales/repair/Repair";
import RepairOrder from "./domain/sales/repair/components/RepairOrder/RepairOrder";
import Time from "./domain/sales/time/Time";
import TrackTime from "./domain/sales/time/components/TrackTime/TrackTime";
import WeeklyOverview from "./domain/sales/time/components/WeeklyOverview/WeeklyOverview";
import MonthlyOverview from "./domain/sales/time/components/MonthlyOverview/MonthlyOverview";
import EditHours from "./domain/sales/time/components/EditHours/EditHours";
import TimeSettings from "./domain/sales/time/components/TimeSettings/TimeSettings";
import SalesEmployees from "./domain/sales/employee/components/Employees";
import ContractsPerEmployee from "./domain/sales/employee/components/ContractsPerEmployee/ContractsPerEmployee";

// Cockpit Sub-Components
import Companies from "./domain/cockpit/master-data/components/Companies/Companies";
import Objects from "./domain/cockpit/master-data/components/Objects/Objects";
import CockpitContracts from "./domain/cockpit/administration/components/Contracts/Contracts";
import CockpitDocuments from "./domain/cockpit/administration/components/Documents/Documents";
import ActiveAssets from "./domain/cockpit/business/components/ActiveAssets/ActiveAssets";
import BillingTenants from "./domain/cockpit/business/components/BillingTenants/BillingTenants";
import Projects from "./domain/cockpit/operations/components/Projects/Projects";
import ServicesBoard from "./domain/cockpit/operations/components/ServicesBoard/ServicesBoard";
import Partners from "./domain/cockpit/operations/components/Partners/Partners";
import LegalTax from "./domain/cockpit/system/components/LegalTax/LegalTax";
import Notifications from "./domain/cockpit/system/components/Notifications/Notifications";
import CockpitSettings from "./domain/cockpit/system/components/Settings/CockpitSettings";
import Overview from "./domain/crm/overview/components/Overview";
import CompaniesContacts from "./domain/crm/companies-contacts/components/CompaniesContacts";
import CrmObjects from "./domain/crm/objects/components/Objects";
import UserRole from "./domain/crm/user-role/UserRole";
import CRMSettings from "./domain/crm/settings/components/CRMSettings";
import RequireAuth from "./routes/RequireAuth";
import AuthSessionHandler from "./routes/AuthSessionHandler";

function App() {
  return (
    <BrowserRouter>
      {/* Globale 401-Behandlung (Session abgelaufen -> Cache leeren + zur Landingpage) */}
      <AuthSessionHandler />
      <Routes>
        
        <Route element={<LandingPageLayout />}>
          <Route path="/produkte" element={<LandingpagePage section="products" />} />
          <Route path="/loesungen" element={<LandingpagePage section="solutions" />} />
          <Route path="/preise" element={<LandingpagePage section="prices" />} />
          <Route path="/" element={<LandingpagePage section="home" />} />
        </Route>

        {/* E-Mail-Verifizierung (oeffentlich erreichbar) */}
        <Route path="/auth/verify" element={<EmailVerification />} />

        {/* AppShell â€“ nach dem Login (Header + TopNavigation + Dashboard/Module).
            RequireAuth prueft vorab die Session ueber /api/auth/me. */}
        <Route
          path="/app"
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />

          {/* Margin Calculator als Kind-Route der AppShell */}
          <Route path="margin-calculator" element={<MarginCalculatorPage />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="kalkulator" element={<Calculator />} />
            <Route path="calculator" element={<Calculator />} />
            <Route path="angebote" element={<Offers />} />
            <Route path="offers" element={<Offers />} />
            <Route path="kunden" element={<Customers />} />
            <Route path="customers" element={<Customers />} />
            <Route path="vertraege" element={<Contracts />} />
            <Route path="contracts" element={<Contracts />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="news" element={<News />} />
            <Route path="bundles" element={<Bundles />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="reports" element={<Reports />} />
            <Route path="team" element={<Team />} />
            <Route path="my-data" element={<MyData />} />
            <Route path="security" element={<Security />} />
            <Route path="license" element={<License />} />
            <Route path="shop-settings" element={<ShopSettings />} />
            <Route path="employee-rights" element={<EmployeeRights />} />
            <Route path="news-management" element={<NewsManagement />} />
            <Route path="quantity-bonuses" element={<QuantityBonuses />} />
          </Route>

          {/* CRM als Kind-Route der AppShell */}
          <Route path="crm" element={<CRMPage />}>
            <Route index element={<Navigate to="Ã¼bersicht" replace />} />
            <Route path="Ã¼bersicht" element={<Overview />} />
            <Route path="firmen-und-kontakte" element={<CompaniesContacts />} />
            <Route path="objekte" element={<CrmObjects />} />
            <Route path="benutzer-und-rollen" element={<UserRole />} />
            <Route path="einstellungen" element={<CRMSettings />} />
          </Route>

          {/* Sales als Kind-Route der AppShell */}
          <Route path="sales" element={<SalesPage />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<SalesDashboard />} />
            <Route path="kunden" element={<SalesCustomers />} />
            <Route path="kunden/kundenliste" element={<SalesCustomerList />} />
            <Route path="kunden/kundenauswertung" element={<CustomerAnalysis />} />
            <Route path="kunden/rechte" element={<Navigate to="/app/sales/mitarbeiter/rechte" replace />} />
            <Route path="kunden/benachrichtigungen" element={<Navigate to="/app/sales/mitarbeiter/benachrichtigungen" replace />} />
            <Route path="vertraege" element={<SalesContracts />} />
            <Route path="vertraege/vvl-liste" element={<SalesVVLList />} />
            <Route path="vertraege/vertragsuebersicht" element={<ContractOverview />} />
            <Route path="vertraege/vvl-kampagnen" element={<VVLCampaign />} />
            <Route path="cash-register" element={<CashRegister />} />
            <Route path="cash-register/neue-entnahme" element={<NewWithdrawal />} />
            <Route path="cash-register/abschluesse" element={<CashUp />} />
            <Route path="cash-register/kassenbericht" element={<CashReport />} />
            <Route path="cash-register/beleghistorie" element={<DocumentHistory />} />
            <Route path="cash-register/belegdetails" element={<DocumentDetails />} />
            <Route path="cash-register/posten" element={<OpenItems />} />
            <Route path="cash-register/angebote" element={<CashRegisterOffers />} />
            <Route path="cash-register/kasse-eroeffnen" element={<OpenCashRegister />} />
            <Route path="cash-register/rechnung-schreiben" element={<Invoice />} />
            <Route path="lager" element={<Stock />} />
            <Route path="lager/uebersicht" element={<Stock />} />
            <Route path="lager/artikelverwaltung" element={<ArticleManagement />} />
            <Route path="lager/wareneingang-buchen" element={<GoodsReceiptBooking />} />
            <Route path="lager/warenausgang-buchen" element={<GoodsIssueBooking />} />
            <Route path="lager/wareneingaenge" element={<GoodsReceived />} />
            <Route path="lager/warenausgaenge" element={<GoodsOut />} />
            <Route path="lager/etiketten-drucken" element={<LabelPrinting />} />
            <Route path="lager/imei-suche" element={<ImeiSearch />} />
            <Route path="lager/mengen-inventur" element={<QuantityInventory />} />
            <Route path="lager/seriennummern-inventur" element={<SerialNumberInventory />} />
            <Route path="lager/ean-inventur" element={<EanInventory />} />
            <Route path="lager/lagerwert" element={<StockValue />} />
            <Route path="lager/inventuren" element={<Inventories />} />
            <Route path="lager/hitliste" element={<RankingList />} />
            <Route path="lager/schwebelager" element={<StockInTransit />} />
            <Route path="reparatur" element={<Repair />} />
            <Route path="reparatur/reparaturauftrag" element={<RepairOrder />} />
            <Route path="mitarbeiter/vertraege-je-mitarbeiter" element={<ContractsPerEmployee />} />
            <Route path="mitarbeiter" element={<SalesEmployees />} />
            <Route path="mitarbeiter/rechte" element={<SalesEmployeeRights />} />
            <Route path="mitarbeiter/tarifuebersicht" element={<SalesRateOverview />} />
            <Route path="mitarbeiter/benachrichtigungen" element={<SalesEmployeeNotifications />} />
            <Route path="zeit" element={<Time />} />
            <Route path="zeit/zeiterfassung" element={<TrackTime />} />
            <Route path="zeit/wochenuebersicht" element={<WeeklyOverview />} />
            <Route path="zeit/monatsuebersicht" element={<MonthlyOverview />} />
            <Route path="zeit/stunden-bearbeiten" element={<EditHours />} />
            <Route path="zeit/einstellungen" element={<TimeSettings />} />
          </Route>

          

          {/* Cockpit als Kind-Route der AppShell */}
          <Route path="cockpit" element={<CockpitPage />}>
            <Route index element={<Navigate to="cockpit" replace />} />
            <Route path="cockpit" element={<CockpitDashboard />} />
            <Route path="dashboard" element={<CockpitDashboard />} />
            <Route path="nachhaltigkeit-und-pflichten" element={<EsgCo2 />} />
            <Route path="esg-co2" element={<Navigate to="../nachhaltigkeit-und-pflichten" replace />} />
            <Route path="esg" element={<EsgCo2 />} />
            <Route path="gesellschaften" element={<Companies />} />
            <Route path="objekte" element={<Objects />} />
            <Route path="projekte" element={<Projects />} />
            <Route path="leistungen-und-board" element={<ServicesBoard />} />
            <Route path="partner-und-dienstleister" element={<Partners />} />
            <Route path="aktive-anlagen" element={<ActiveAssets />} />
            <Route path="abrechnung-und-mieter" element={<BillingTenants />} />
            <Route path="vertragsmanagement" element={<CockpitContracts />} />
            <Route path="dokumente-und-freigaben" element={<CockpitDocuments />} />
            <Route path="recht-und-steuern" element={<LegalTax />} />
            <Route path="mitteilungen" element={<Notifications />} />
            <Route path="einstellungen" element={<CockpitSettings />} />

            <Route path="master-data">
              <Route
                index
                element={<div>Bitte wÃ¤hlen Sie einen Bereich aus.</div>}
              />
              <Route path="companies" element={<Companies />} />
              <Route path="objects" element={<Objects />} />
            </Route>

            <Route path="operations">
              <Route
                index
                element={<div>Bitte wÃ¤hlen Sie einen Bereich aus.</div>}
              />
              <Route path="projects" element={<Projects />} />
              <Route path="services-board" element={<ServicesBoard />} />
              <Route path="partners" element={<Partners />} />
            </Route>

            <Route path="business">
              <Route
                index
                element={<div>Bitte wÃ¤hlen Sie einen Bereich aus.</div>}
              />
              <Route path="active-assets" element={<ActiveAssets />} />
              <Route path="billing-tenants" element={<BillingTenants />} />
            </Route>

            <Route path="administration">
              <Route
                index
                element={<div>Bitte wÃ¤hlen Sie einen Bereich aus.</div>}
              />
              <Route path="contracts" element={<CockpitContracts />} />
              <Route path="documents" element={<CockpitDocuments />} />
            </Route>

            <Route path="system">
              <Route
                index
                element={<div>Bitte wÃ¤hlen Sie einen Bereich aus.</div>}
              />
              <Route path="legal-tax" element={<LegalTax />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="settings" element={<CockpitSettings />} />
            </Route>
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
